import { createEffect } from 'effector/compat';

export const delayFx = createEffect().use(async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      return resolve(false);
    }, 2000);
  });
});
